// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage";
import CartPage from "./pages/CartPage";
import CheckoutAddress from "./pages/CheckoutAddress";
import CheckoutPayment from "./pages/CheckoutPayment";
import ProductDetailPage from "./pages/ProductDetailPage";
import WishlistPage from "./pages/WishlistPage";
import "./index.css";

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/checkout/address" element={<CheckoutAddress />} />
          <Route path="/checkout/payment" element={<CheckoutPayment />} />
          <Route path="/account" element={<AccountPlaceholder />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </CartProvider>
    </BrowserRouter>
  );
}

function AccountPlaceholder() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, padding: "40px 20px" }}>
      <div style={{ fontSize: 64 }}>👤</div>
      <h2 style={{ fontSize: 24, fontWeight: 700 }}>My Account</h2>
      <p style={{ color: "#aaa", fontSize: 14 }}>Login / Register to view your account</p>
      <button style={{ padding: "12px 40px", background: "#1a9b8a", color: "white", border: "none", borderRadius: 4, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
        LOG IN / REGISTER
      </button>
    </div>
  );
}

function NotFound() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, padding: "40px 20px", textAlign: "center" }}>
      <div style={{ fontSize: 72 }}>👻</div>
      <h2 style={{ fontSize: 32, fontWeight: 900, fontFamily: "var(--font-display)" }}>PAGE NOT FOUND</h2>
      <p style={{ color: "#aaa" }}>The page you're looking for doesn't exist</p>
      <a href="/" style={{ padding: "12px 40px", background: "#1a1a1a", color: "white", borderRadius: 4, fontWeight: 700, fontSize: 14 }}>
        GO TO HOME
      </a>
    </div>
  );
}
